// 一括アクション（WEB共有・PDF共有・求職者に提案）で一度に処理できる求人数の上限 (Issue #2969)
export const BULK_ACTION_MAX_COUNT = 100;

export const STATUS_ITEMS = [
  {
    label: '公開',
    value: 'published',
  },
  {
    label: '下書き',
    value: 'draft',
  },
];

// 雇用形態の選択肢。ラベルはサーバ側 ProvidedJobPostDecorator#employment_type_text と一致させる。
// 空文字は「自動判定」= nil で保存され、保存時に分類器が求人本文から判定する
export const EMPLOYMENT_TYPE_ITEMS = [
  {
    label: '自動判定',
    value: '',
  },
  {
    label: '正社員',
    value: 'full_time',
  },
  {
    label: '契約社員',
    value: 'contract',
  },
  {
    label: '業務委託',
    value: 'outsourcing',
  },
  {
    label: '派遣',
    value: 'dispatch',
  },
  {
    label: 'アルバイト・パート',
    value: 'part_time',
  },
  {
    label: 'その他',
    value: 'other',
  },
];

export const TAB_ITEMS = [
  {
    label: '求人情報',
    value: 'info',
  },
  {
    label: '提案管理',
    value: 'suggested_candidates',
  },
  {
    label: 'マッチング管理',
    value: 'job_change_processes',
  },
  {
    label: 'アライアンス',
    value: 'alliance',
  },
  {
    label: 'その他設定',
    value: 'settings',
  },
] as const;
